/* ==========================================================================
   DCM — Editorial Motion Layer (JS)
   Único comportamiento nuevo: un pulso visual discreto cuando el subtotal
   del carrito cambia de valor. No toca theme.js ni la lógica del carrito.

   Para desactivar: elimina el <script> a este archivo en layout/theme.liquid.
   ========================================================================== */
(function () {
  "use strict";

  function pulse(el) {
    if (!el) return;
    el.classList.remove("is-updating");
    // eslint-disable-next-line no-unused-expressions
    void el.offsetWidth; // fuerza reflow para poder re-disparar la animación
    el.classList.add("is-updating");
  }

  function observeTextChanges(selector) {
    var el = document.querySelector(selector);
    if (!el) return;
    var last = el.textContent;
    var mo = new MutationObserver(function () {
      if (el.textContent !== last) {
        last = el.textContent;
        pulse(el);
      }
    });
    mo.observe(el, { childList: true, characterData: true, subtree: true });
  }

  function rotateAnnouncement() {
    var bar = document.querySelector("[data-announcement-rotate]");
    if (!bar) return;
    var items = bar.querySelectorAll(".announcement__item");
    if (items.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return; // deja el primer mensaje fijo, sin rotación
    var i = 0;
    setInterval(function () {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, 4500);
  }

  document.addEventListener("DOMContentLoaded", function () {
    observeTextChanges("[data-cart-subtotal]");
    rotateAnnouncement();
  });
})();
